// transaction object keys:
export const QTY = 'quantity';
export const NEW_QTY = 'newQty';
export const QTY_ABBREVIATED = 'qty';
export const TICKER_OBJECT = 'tickerObject';
